import React from 'react';
import { ArrowLeft } from 'react-feather';
import { MarginProps } from 'styled-system';

import { Link } from '../../../../shared/components/DiComponents';

interface IProps extends MarginProps {
  onClick: () => void;
}

export default function BackLink({ onClick, ...props }: IProps) {
  return (
    <Link
      onClick={onClick}
      display={{ _: 'flex', lg: 'none' }}
      alignItems="center"
      mb="md"
      {...props}
    >
      <ArrowLeft size="1em" /> Back
    </Link>
  );
}
